import { render, staticRenderFns } from "./CardPlan.vue?vue&type=template&id=e98225aa&lang=pug&"
import script from "./CardPlan.vue?vue&type=script&lang=ts&"
export * from "./CardPlan.vue?vue&type=script&lang=ts&"
import style0 from "./CardPlan.vue?vue&type=style&index=0&id=e98225aa&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports